import { render, staticRenderFns } from "./ParamSkeleton.vue?vue&type=template&id=13c99a2a"
var script = {}
import style0 from "./ParamSkeleton.vue?vue&type=style&index=0&id=13c99a2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports